import { Component, OnInit, Inject, OnDestroy } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { UiHelper } from '@helpers/ui.helper';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { environment } from '@environments/environment';
import { Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Component({
  selector: 'lugas-limit-dialog',
  templateUrl: '../sharedTemplates/lugas-limit.dialog.html',
})
export class LugasLimitDialog {
  inputTypeModel;
  warningMessage = '';
  isVerificationSow = false;
  input_Step = '1';

  saveLimitSubject = new Subject();
  isOldCustomer = false;
  selectedDate = new Date('Mon Feb 20 2023 14:51:21 GMT+0300 (GMT+03:00)').getTime(); //Bu tarihten itibaren yeni kayıt olunan kullanıcıları tespit edebilmek için yazıldı
  thirdInputValue = '99999';
  constructor(
    public dialogRef: MatDialogRef<LugasLimitDialog>,
    private _ApiService: ApiService,
    public _LocalizationService: LocalizationService,
    public _UserHelper: UserHelper,
    public _DataHelper: DataHelper,
    public _UiHelper: UiHelper
  ) {
    if (this._UserHelper.customerUser.ContractAcceptedDate) {
      new Date(this._UserHelper.customerUser.ContractAcceptedDate);

      this.isOldCustomer = new Date(this._UserHelper.customerUser.ContractAcceptedDate).getTime() < this.selectedDate ? true : false;
    }

    this.saveLimitSubject.pipe(throttleTime(1500)).subscribe(x => {
      this.saveSelfLimitsData();
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showTabsMenuMobile(e?) {
    this.dialogRef.close();
    this._UiHelper.b3000SetAcountMobileState('open', 8, 0);
  }
  backButton() {
    this.isVerificationSow = false;
    this.warningMessage = '';
    this._ApiService.getWalletList().then(result => {
      this._UserHelper.setWalletList(result);
    });
  }
  change_Tab(eventName: string) {
    //Flowda Belirtildiği gibi 1.İnput 10.000 €, 2.İnput 1.000 €,3.İnput 99.999 €

    if (eventName === 'firstStep') {
      // 1.input seçiliyse
      if (this.inputTypeModel === '10000') {
        this.warningMessage = 'step_1';
      } else if (this.inputTypeModel === '1000') {
        this.warningMessage = 'step_2';
      } else if (this.inputTypeModel === this.thirdInputValue) {
        this.warningMessage = 'step_3';
      }
    } else if (eventName === 'cancel') {
      this.warningMessage = '';
    }
  }
  saveLimitChange(e) {
    this.saveLimitSubject.next(e);
  }

  saveSelfLimitsData() {
    //Parametrik olarak alınan limitType 3 aylık deposit ,1 stake ve lost, 2 diğer günlük ve haftalık
    //Lost Limit ve Stake Limit beraber Setleneceği için 2 ApiCall yapılacak
    //DB tarafında TimeType Karşılığı Day--> 1, Week--> 2 ,Month--> 3
    //DB tarafında LimitType Karşılığı Stake--> 1, Deposit --> 2 ,Loss--> 3

    //Modalda 1.seçenek 10000 , 2. seçenek 1000, 3. seçenek 99999

    const translator = new TranslatePipe(this._LocalizationService);

    if (!this._DataHelper.selectedWallet.IsShufa && this.inputTypeModel === '10000') {
      this._ApiService.registerSow().then(result => {
        if (result === '""') {
          const t_message = translator.transform('b3000_Withdraw_Text_2', null);

          this._UiHelper.errorSnackBar(t_message, '');
          this.isVerificationSow = false;
          return 'error|System Error';
        } else {
          this.isVerificationSow = true;
        }
      });
    } else if (this._DataHelper.selectedWallet.IsShufa && this.inputTypeModel === '10000') {
      this._ApiService.saveSelfLimits2(this.inputTypeModel, 2, 3).then(result => {
        if (result.code == '') {
          return 'error|System Error';
        } else {
          if (result.code == 'error') {
            this._UiHelper.errorSnackBar(result.message, '');
          } else if (result.code == 'errorcode') {
            const t_message = translator.transform(result.message, null);

            this._UiHelper.errorSnackBar(t_message, '');
          } else if (result.code == 'success') {
            const t_message = translator.transform(result.message, null);
            this._UiHelper.successSnackBar(t_message, '');
            this.onNoClick();
            this._ApiService.getClient().then(u => {
              this._UserHelper.setUser(u);
            });
            // this._ApiService.getWalletList().then((result) => {
            //   // this._UserHelper.walletList=result;
            //   this._UserHelper.setWalletList(result);
            // });
          }
        }
      });
    } else if (this.inputTypeModel === this.thirdInputValue) {
      this._ApiService.saveSelfLimits2(this.inputTypeModel, 2, 3).then(result => {
        if (result.code == '') {
          return 'error|System Error';
        } else {
          if (result.code == 'error') {
            this._UiHelper.errorSnackBar(result.message, '');
          } else if (result.code == 'errorcode') {
            const t_message = translator.transform(result.message, null);

            this._UiHelper.errorSnackBar(t_message, '');
          } else if (result.code == 'success') {
            const t_message = translator.transform(result.message, null);
            this._UiHelper.successSnackBar(t_message, '');
            this.onNoClick();
            this._ApiService.getClient().then(u => {
              this._UserHelper.setUser(u);
            });
            // this._ApiService.getWalletList().then((result) => {
            //   // this._UserHelper.walletList=result;
            //   this._UserHelper.setWalletList(result);
            // });
          }
        }
      });
    } else if (this.inputTypeModel === '1000') {
      this._ApiService.saveSelfLimits2(this.inputTypeModel, 2, 3).then(result => {
        if (result.code == '') {
          return 'error|System Error';
        } else {
          if (result.code == 'error') {
            if (result.message === 'The player has not been registered yet., ') {
              const translator = new TranslatePipe(this._LocalizationService);
              const t_message2 = translator.transform('errorcodeRegister2', null);
              const navigateLink = environment.contactUrl;

              this._UiHelper.errorSnackBarWithAction(result.message, t_message2, navigateLink);
            } else {
              this._UiHelper.errorSnackBar(result.message, '');
            }
          } else if (result.code == 'errorcode') {
            if (result.message === 'The player has not been registered yet., ') {
              const translator = new TranslatePipe(this._LocalizationService);
              const t_message2 = translator.transform('errorcodeRegister2', null);

              const navigateLink = environment.contactUrl;
              this._UiHelper.errorSnackBarWithAction(result.message, t_message2, navigateLink);
            } else {
              const t_message = translator.transform(result.message, null);

              this._UiHelper.errorSnackBar(t_message, '');
            }
          } else if (result.code == 'success') {
            const t_message = translator.transform(result.message, null);
            this._UiHelper.successSnackBar(t_message, '');
            this.onNoClick();
            this._ApiService.getClient().then(u => {
              this._UserHelper.setUser(u);
            });
            // this._ApiService.getWalletList().then((result) => {
            //   // this._UserHelper.walletList=result;
            //   this._UserHelper.setWalletList(result);
            // });
          }
        }
      });
    }
  }
}
